import { Tag, Percent, Package } from 'lucide-react';

/**
 * Small reserved-pricing badge block. Renders only if buyer has terms for this product.
 * Compact: shows price, discount, and MOQ in a gold-accented card.
 */
export default function ReservedTerms({ terms, note, compact = false }) {
  if (!terms && !note) return null;
  const price = terms?.price;
  const currency = terms?.currency || 'EUR';
  const discount = terms?.discount_pct;
  const moq = terms?.moq;
  const termNote = terms?.note;
  const anyStructured = price || discount != null || moq != null;

  if (!anyStructured && !note && !termNote) return null;

  return (
    <div data-testid="reserved-terms" className={`mt-3 border-l-2 border-[#C5A059] bg-[#C5A059]/10 ${compact ? 'p-2' : 'p-3'}`}>
      <div className={`text-[10px] uppercase tracking-[0.3em] text-[#C5A059] ${compact ? 'mb-1' : 'mb-2'}`}>— Your reserved terms</div>
      {anyStructured && (
        <div className={`flex flex-wrap gap-x-4 gap-y-1 text-sm ${compact ? 'text-xs' : ''}`}>
          {price && (
            <span className="inline-flex items-center gap-1 font-serif">
              <Tag className="w-3.5 h-3.5 text-[#C5A059]" />
              <strong>{price} {currency}</strong>
            </span>
          )}
          {discount != null && discount !== '' && (
            <span className="inline-flex items-center gap-1">
              <Percent className="w-3.5 h-3.5 text-[#C5A059]" />
              {discount}% off
            </span>
          )}
          {moq != null && moq !== '' && (
            <span className="inline-flex items-center gap-1">
              <Package className="w-3.5 h-3.5 text-[#C5A059]" />
              MOQ {moq}
            </span>
          )}
        </div>
      )}
      {termNote && <div className={`text-[#3D2817]/70 ${compact ? 'text-xs mt-1' : 'text-sm mt-1'}`}>{termNote}</div>}
      {note && <div className={`text-[#3D2817]/70 italic ${compact ? 'text-xs mt-1' : 'text-sm mt-1'}`}>{note}</div>}
    </div>
  );
}
